<template>
<span class="string">
  {{ uri }}
</span>  
</template>
<script>
export default {
  
  props: {
    uri: {
      type: String
    }
  }

}
</script>